<template>
  <div class="client-balance-box">
    <template v-if="pageIndex == 0">
      <div class="client-balance-box-top">余额</div>
      <div class="client-balance-box-balance">
        <div class="scroe">
          <span>{{ price }}</span>
          <span class="company">金榜币</span>
        </div>
        <span class="detail" @click="openDetail">查看明细</span>
      </div>
      <div class="client-balance-box-content">
        <div class="info">
          <div class="title">充值</div>
          <ul>
            <li v-for="(price, index) in priceArr" :key="index" :class="[{ 'active': activeIndex === index }]" @click="selectPrice(index, price.id)">{{ price.markingPrice }}</li>
          </ul>
          <h3>充值说明：</h3>
          <p>1、因充值政策原因，充值仅限指定价格；</p>
          <p>2、余额为虚拟币，充值后的余额不会过期；</p>
          <p>3、充值如遇到问题，请关注【我要尚壹本】微信公众号，向我们反馈您的问题，我们会为您解决。</p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="client-balance-box-top">
        <i class="balance-left el-icon-arrow-left" @click="toPageIndex"></i>
        余额-查看明细
      </div>
      <div class="client-balance-box-list">
        <template v-if="balanceRecord.length">
          <div class="item" v-for="(item, index) in balanceRecord">
            <div class="top">
              <span class="right">
                <span v-if="item.payWayCode == 2">-</span>
                <span v-else>+</span>
                {{ item.orderAmount }}</span>
              <span class="left">{{ item.payWayName }}-{{ item.name }}</span>
            </div>
            <div class="bottom">
              <span class="right">余额：{{ item.balance }}</span>
              <span class="left">{{ new Date(item.paySuccessTime).format('yyyy-MM-dd hh:mm:ss')}}</span>
            </div>
          </div>
          <br>
          <el-pagination
            v-if="balanceRecordTatal > 10"
            :current-page.sync="paramsList.pageIndex"
            @current-change="handleCurrentChange"
            :page-size="10"
            layout="prev, pager, next"
            :total="balanceRecordTatal"
            style="float: left"
          >
          </el-pagination>
        </template>
        <template v-else>
          <div class="client-balance-box-list-tip">暂无充值记录</div>
        </template>
      </div>
    </template>
    <div class="pay-box" v-if="dialogVisible">
      <div class="pay-content">
        <div class="title">
          <i class="balance-right el-icon-close" @click="deleteDialog"></i>
          请选择支付方式
        </div>
        <div class="prics">￥{{ orderInfo.orderAmount }}</div>
        <div class="vx-pay">
          <div class="price-item">
            <img src="@/assets/images/client/vx.png" alt="">
            <span class="text">微信支付</span>
            <img class="selest" v-if="!wxPay" src="@/assets/images/client/dui.png" alt="" @click="wxPayFun">
            <img class="selest" v-else src="@/assets/images/client/dui-ok.jpg" alt="" @click="wxPayFun">
          </div>
          <div v-if="wxPay">
            <qrCode class="right_QrCode_img" :pay-code-url="payCodeUrl"></qrCode>
          </div>
        </div>
        <div class="vx-pay">
          <div class="price-item">
            <img src="@/assets/images/client/zfb.png" alt="">
            <span class="text">支付宝支付</span>
            <img class="selest" src="@/assets/images/client/dui.png" @click="alipayPayment" alt="">
          </div>
        </div>
      </div>
    </div>
     <div v-html="html"></div>
  </div>
</template>
<script>
import qrCode from "@/components/qr-code/qr-code-for-wxpay"
export default {
  data() {
    return {
      priceArr: [],
      pageIndex: 0, // 支付页 1  列表页 1
      activeIndex: null,
      price: 0, // 账户余额
      paramsList: {
        pageIndex: 1,
        pageSize: 10,
        userId: null
      },
      balanceRecord: [],
      paramsListLoading: false,
      uid: null,
      orderInfo: {}, // 订单信息
      dialogVisible: false, // 支付弹层
      payCodeUrl: '', // 微信支付二维码
      wxPay: false,
      html: '',
      balanceRecordTatal: 0
    }
  },
  components: {
    qrCode
  },
  methods: {
    // 分页问题
    handleCurrentChange (val) {
      this.paramsList.pageIndex = +val
      this.$HTTP.executePost(`${this.$APIS.GET_BALANCE_RECORD}?userId=${this.paramsList.userId}&pageIndex=${this.paramsList.pageIndex}&pageSize=${this.paramsList.pageSize}`, {}, this).then((res) => {
        const { data, code, msg } = res
        if (code === 0) {
          this.balanceRecord = data.list
          this.balanceRecordTatal = data.total
        }
      })
    },
    // 支付宝支付
    alipayPayment() {
      let param = {
        orderNumber: this.orderInfo.orderNo,
        userId: this.uid
      }
      // 请求支付宝支付接口
      this.$axios.post('alipay/vip/pay', param).then(res => {
        const { data } = res
        if (data.code === 0) {
          if (data.data.length) {
            this.html = data.data;
            this.$nextTick(() => {
              document.forms[0].submit()
            })
          } else {
            this.$message.error(data.msg)
          }
        }
      })
    },
    // 删除弹层
    deleteDialog () {
      this.dialogVisible = false
      this.wxPay = false
    },
    wxPayFun () {
      //在这里请求接口,通过订单获得生成的二维码
      let params = {
        orderNumber: this.orderInfo.orderNo,
        userId: this.uid
      }
      if (this.wxPay) {
        this.wxPay = false
        return false
      }
      this.$axios.post('wxpay/create-vip-pre-order', params).then(res => {
        const { data, status } = res
        if (status === 200) {
          if (data.code === 0) {
            this.payCodeUrl = data.data.code_url;
            this.wxPay = true;
            this.quertOrderStatus();
          } else {
            this.$message.error("获得支付二维码失败,请重试!")
          }
        }
      })
    },
    selectPrice (index, goodsId) {
      // 高亮
      this.activeIndex = index
      // 创建订单
      let params = {
        userId: this.uid,
        tradeGoodsId: goodsId,
      }
      this.$axios.post('vip/order/add', params).then((resD) => {
        const { status, data } = resD
        if (status === 200) {
          if (data.code === 0) {
            this.orderInfo = data.data
            this.dialogVisible = true
          }
        }
      })
    },
    toPageIndex () {
      this.pageIndex = 0
    },
    openDetail () {
      this.pageIndex = 1
      // this.paramsListLoading = true
      // 获取用户明交易明细
      this.$HTTP.executePost(`${this.$APIS.GET_BALANCE_RECORD}?userId=${this.paramsList.userId}&pageIndex=${this.paramsList.pageIndex}&pageSize=${this.paramsList.pageSize}`, {}, this).then((res) => {
        const { data, code, msg } = res
        if (code === 0) {
          this.balanceRecord = data.list
          this.balanceRecordTatal = data.total
        }
      })
    },
    quertOrderStatus(){
      // 查看订单状态
      this.$axios.get(`vip/order/find/${this.orderInfo.id}`).then(res => {
        const { status, data } = res
        if (status === 200) {
          if (data.code === 0) {
            if (data.data.status != null && data.data.status == '1') {
              this.$message.success('支付成功')
              // 去弹层
              this.dialogVisible = false
              this.wxPay = false
              // 订单数据清空
              this.orderInfo = {}
              // 获取余额数据
              this.$HTTP.executeGet(`${this.$APIS.GET_USER_BLANCE}/${this.uid}`, this).then((res) => {
                const { data, code, msg } = res
                if (code === 0) {
                  this.price = data
                } else {
                  this.$message.error(msg);
                }
              })
            } else {
              setTimeout(() => {
                this.quertOrderStatus();
              }, 2000);
            }
          }
        }
      })
    },
  },
  created () {
    // 获取用户余额信息
    let userInfo = JSON.parse(localStorage.getItem('userinfo'))
    this.paramsList.userId = userInfo.id
    this.uid = userInfo.id
    this.$HTTP.executeGet(`${this.$APIS.GET_USER_BLANCE}/${userInfo.id}`, this).then((res) => {
      const { data, code, msg } = res
      if (code === 0) {
        this.price = data
      } else {
        this.$message.error(msg);
      }
    })

    this.$HTTP.executeGet(`${this.$APIS.GET_GOODS_LIST}`, this).then((res) => {
      const { data, code, msg } = res
      if (code === 0) {
        this.priceArr = data
      } else {
        this.$message.error(msg);
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.client-balance-box {
  width: 540px;
  height: 700px;
  margin: 0 auto;
  background: #f4f4f4;
  font-size: 16px;
  position: relative;
  z-index: 11;
  &-top {
    height: 40px;
    width: 100%;
    font-size: 16px;
    background: #fff;
    border-bottom: 1px solid #cccccc;
    line-height: 40px;
    text-align: center;
    .balance-left {
      float: left;
      margin-left: 20px;
      margin-top: 12px;
      font-size: 20px;
      cursor: pointer;
    }
  }
  &-balance {
    height: 155px;
    width: 100%;
    background: #fff;
    text-align: center;
    color: #585858;
    .scroe {
      font-size: 26px;
      font-weight: 800;
      color: #010101;
      padding-top: 50px;
      padding-bottom: 14px;

      .company {
        font-size: 16px;
        color: #585858;
        font-weight: 400;
        margin-left: 6px;
      }
    }
    .detail {
      color: #5b317d;
      font-size: 16px;
      margin-top: 14px;
      cursor: pointer;
    }
  }
  &-content {
    height: 520px;
    margin-top: 5px;
    background: #fff;
    .info {
      width: 455px;
      height: 520px;
      margin: 0 auto;
      .title {
        height: 56px;
        line-height: 56px;
      }
      ul {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
          width: 134px;
          height: 59px;
          line-height: 59px;
          font-size: 20px;
          line-height: 59px;
          font-weight: 600;
          color: #5b2f7c;
          border: 1px solid #5c307d;
          border-radius: 5px;
          margin-bottom: 15px;
          text-align: center;
          cursor: pointer;
        }
        li:hover {
          color: #fff;
          background: #5c307d;
        }
        .active {
          color: #fff;
          background: #5c307d;
        }
      }
      h3 {
        font-size: 16px;
        font-weight: 800;
        color: #aaaaaa;
        margin-top: 100px;
      }
      p {
        // line-height: 19px;
        font-size: 16px;
        color: #ababab;
      }
    }
  }
  &-list {
    width: 100%;
    height: 675px;
    background: #fff;
    margin-top: 5px;
    &-tip {
      width: 100%;
      text-align: center;
      line-height: 200px;
    }
    .item {
      padding: 8px 20px;
      border-bottom: 1px solid #cccccc;
      .top {
        font-size: 16px;
        color: #585858;
        line-height: 25px;
        .right {
          float: right;
        }
      }
      .bottom {
        font-size: 14px;
        color: #aaaaaa;
        line-height: 20px;
        .right {
          float: right;
        }
      }
    }
  }
  .pay-box {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
    background: rgba(0, 0, 0, .5);
    .pay-content {
      width: 288px;
      min-height: 300px;
      margin: 150px auto;
      padding-bottom: 50px;
      background: #fff;
      border-radius: 4px;
      overflow: hidden;
      .title {
        height: 40px;
        background: #5c307d;
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 40px;
        .balance-right {
          font-size: 20px;
          margin-top: 13px;
          color: #fff;
          margin-right: 15px;
          float: right;
          cursor: pointer;
        }
      }
      .prics {
        height: 70px;
        background: #fff;
        font-size: 22px;
        font-weight: 900;
        color: #ff0000;
        line-height: 70px;
        text-align: center;
      }
      .vx-pay {
        /deep/ .qr_code {
          margin: 0 auto;
        }
        border-bottom: 1px solid #b3b3b3;
        .price-item {
          height: 60px;
          background: #fff;
          
          display: flex;
          justify-content: space-around;
          align-items: center;
          img {
            width: 38px;
          }
          .text {
            display: inline-block;
            width: 140px;
          }
          .selest {
            width: 24px;
            cursor: pointer;
          }
        }
      }
    }
    
  }
}
</style>


